import { Component, Input } from '@angular/core';
import { DialogService } from '@app/common/services/dialog.service';
import { OccupationApproveComponent } from '@app/ps/occupations/components/occupation-approve/occupation-approve.component';
import { UserNamePipe } from '@app/common/pipes/username.pipe';
import { ApproveFinalSolutionTypeService } from '@app/common/services/approve-final-solution-type.service';
import { FinalSolutionStateEnum } from '@app/ps/enums/final-solution-state.enum';

@Component({
  selector: 'occupation-final-solution',
  templateUrl: './occupation-final-solution.component.html',
  styleUrls: ['./occupation-final-solution.component.scss'],
})
export class OccupationFinalSolutionComponent {
  @Input() data: any;
  @Input() feature: any;

  readonly FinalSolutionStateEnum = FinalSolutionStateEnum;

  constructor(
    private dialogService: DialogService,
    private userNamePipe: UserNamePipe,
    public approveFinalSolutionTypeService: ApproveFinalSolutionTypeService,
  ) {}

  onApprove(): void {
    const dialog = this.dialogService.open(OccupationApproveComponent, { data: { occupationId: this.data.id } });
    const sub = dialog.afterClosed.subscribe((result) => {
      if (!result) {
        sub.unsubscribe();
        return;
      }

      Object.assign(this.data, {
        final_solution_type_name: result.finalSolutionType.name,
        final_solution_type_id: result.finalSolutionType.id,
        final_solution_state: result.finalSolutionState,
        final_solution_reason_cancellation: result.finalSolutionReasonCancellation,
        final_solution_note: result.finalSolutionNote,
        final_solution_approver_fullname: this.userNamePipe.transform(result.finalSolutionApprover),
        final_solution_date: result.finalSolutionDate,
        }
      );

      const templateRows = this.feature.featureData.templateProperties.rows;
      this.feature.rows = templateRows
        .filter(row => typeof row.show !== 'function' || row.show(this.feature))
        .map(row => ({
          data: row.data(this.feature),
          label: typeof row.getLabel === 'function' ? row.getLabel(this.feature) : row.label,
          template: row.template,
          className: row.className,
        }));

      sub.unsubscribe();
    });
  }
}
